import StandCommentsPage from "./stand-comments-page";
import CommentsHooks from "./hooks";
import CommentsHelpers from "./helpers";

const StandComments = {
    Page: StandCommentsPage,
    Hooks: CommentsHooks,
    Helpers: CommentsHelpers
};

export default StandComments;
